<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Siparis"
    }
</script>

<style scoped>

</style>